// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

Vue.config.productionTip = false
Vue.component('icon', Icon)
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)

var numeral = require('numeral')
Vue.filter('currency', function (value) {
  return numeral(value).format('0,0.00') // displaying other groupings/separators is possible, look at the docs
})
Vue.filter('percentage', function (value) {
  return numeral(value).format('0,0.00') + '%' // displaying other groupings/separators is possible, look at the docs
})
Vue.filter('integer', function (value) {
  return numeral(value).format('0,0') // displaying other groupings/separators is possible, look at the docs
})
Vue.filter('size', function (value) {
  var divisor = 1
  var suffix = ''
  if (value > 1099511627776) {
    divisor = 1099511627776
    suffix = 'tb'
  } else if (value > 1073741824) {
    divisor = 1073741824
    suffix = 'gb'
  } else if (value > 1048576) {
    divisor = 1048576
    suffix = ' mb'
  } else if (value > 1024) {
    divisor = 1024
    suffix = ' kb'
  }
  return (value / divisor).toFixed(2) + suffix
})
Vue.prototype.$filters = Vue.options.filters
Vue.component('splitpanes', Splitpanes)
Vue.component('pane', Pane)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

import {authenticationService} from './services/AuthenticationService'

/**
 * This code will check if the page is secure and redirect the user to the login page if the user have not logged-in
 */
router.beforeEach((to, from, next) => {
  console.log('router: ' + to.path + ' secure=' + to.meta.secure)
  if (to.meta.secure) {
    // console.log('router: page is secure, checking if user has authenticated')
    if (authenticationService.isAuthenticated() === false) {
      // console.log('router: User has not authenticated, redirecting to login page at /login')
      next('/login')
      return
    }
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js